import React from "react";
import { parse } from "dom-parser-react";
import { ViewText } from "../ViewStyle/ViewStyle";

export default function RenderHTML({
  content,
}: Record<string, any>): JSX.Element {
  let output: any;
  let i = -1;
  let result = 0;

  const newStyle = ' style="color:#0000EE; text-decoration:underline;" ';
  const lengthStyle = newStyle.length;

  if (content.includes("href")) {
    while (result != -1) {
      result = content.indexOf("href", i + 1);

      const location = result - 1;

      output = [
        content.slice(0, location),
        newStyle,
        content.slice(location),
      ].join("");

      i = result + lengthStyle;
      content = output;
    }
  } else output = content;

  // parse the content to return HTMLString
  const htmlBlog = parse(output, {
    createElement: React.createElement,
    Fragment: React.Fragment,
  });

  return (
    <div>
      <ViewText textColor="black">{htmlBlog}</ViewText>
    </div>
  );
}
